import axios, { getEnv } from '../../../services/api';

export const ProjetoAcoesService = {
    findAll: async (params, body = {}, source) => {
        try {
            const response = await axios.post(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/consultar`,
                body,
                {
                    params,
                    cancelToken: source?.token,
                }
            );
            if (source) {
                source.cancel('Operação cancelada pelo usuário');
            }
            return response.data;
        } catch (error) {
            console.log('error', error);
            return error;
        }
    },

    find: async () => {
        try {
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos`
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    getOptions: async (cadastro = false) => {
        try {
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/opcoes?cadastro=${cadastro}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    findPratif: async (idPratif) => {
        try {
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/pratif/${idPratif}`);
            return response.data;
        } catch (error) {
            return error;
        }
    },

    findById: async (idPratif) => {
        try {
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/${idPratif}/`
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    findRegionaisById: async (idAcao) => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/regional/${idAcao}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    save: async (body) => {
        const response = await axios.post(
            `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos`,
            body
        );
        return response.data;
    },
    saveRegional: async (body) => {
        const response = await axios.post(
            `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/regional`,
            body
        );
        return response.data;
    },

    edit: async (body) => {
        const response = await axios.put(
            `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos`,
            body
        );
        return response.data;
    },
    editRegionais: async (body) => {
        const response = await axios.put(
            `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/regional`,
            body
        );
        return response.data;
    },

    delete: async (id) => {
        try {
            return await axios.put(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/alterar-status-aprovacao?idProjeto=${id}&statusAprovacao=REPROVADO`
            );
        } catch (error) {
            return error;
        }
    },

    changeStatus: async (idProjeto) => {
        try {
            return await axios.put(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/${idProjeto}`
            );
        } catch (error) {
            throw error;
        }
    },

    getFilterOptions: async () => {
        try {
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/opcoes`
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    ufOptions: async () => {
        try {
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/ufs`
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    searchInput: async (body, params, source) => {
        const response = await axios.post(
            `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/consultar`,
            body,
            {
                params,
                cancelToken: source.token,
            }
        );
        source.cancel('Operação cancelada pelo usuário');
        return response.data;
    },

    consultar: async (body, params) => {
        const response = await axios.post(
            `${await getEnv(
                'REACT_APP_URL_SERVICE'
            )}/v1/sas/projetos/consultar?page=0&linesPerPage=10&orderBy=id&direction=ASC`,
            body,
            {params}
        );
        return response.data;
    },
    getPedants: async (body = {}) => {
        const response = await axios.post(
            `${await getEnv(
                'REACT_APP_URL_SERVICE'
            )}/v1/sas/projetos/buscar-inativos`,
            body
        );
        return response.data;
    },
};
